import { computed, ComputedRef, Ref } from 'vue';
import { Instance } from '../api/Instance';
import {
  AttributeGroup,
  PrmRelationship,
  PrmRelationshipTypeEnum,
} from '@/common/services/swagger/index.defs';

export interface PrmData {
  attributeGroup?: AttributeGroup;
  prm?: PrmRelationship;
}

export interface PrmDataSetupExports {
  prmData: ComputedRef<PrmData[]>;
}

export const prmDataSetup = (instance: Ref<Instance | undefined>): PrmDataSetupExports => {
  const prmData = computed(() => {
    const store = instance.value?.store;
    const hideWhereUsed =
      store?.options.components?.common?.hideWhereUsed ||
      store?.data.productDetail?.item?.hideWhereUsed;
    const data: PrmData[] = [];
    const attributeGroups = store?.data.attributeGroups?.items || [];
    const prmItems = (store?.data.prm?.items || []).filter(
      (prm: PrmRelationship) =>
        !hideWhereUsed ||
        (prm.type !== PrmRelationshipTypeEnum.WhereUsed &&
          prm.type !== PrmRelationshipTypeEnum.SparePartUsedOnList)
    );
    for (const attributeGroup of attributeGroups) {
      if (attributeGroup.visible) {
        if (attributeGroup.relationshipCode) {
          const prm: PrmRelationship | undefined = prmItems.find(
            (prm: PrmRelationship) => prm.code === attributeGroup.relationshipCode
          );
          if (prm) {
            data.push({ prm, attributeGroup });
            prmItems.splice(prmItems.indexOf(prm), 1);
          }
        } else {
          data.push({ attributeGroup });
        }
      }
    }
    return data.concat(prmItems.map((prm: PrmRelationship) => ({ prm })));
  });
  return { prmData };
};
